
  export const filesExtToContentTypes = (fileName) => {
  let extToContentTypes = {
    "csv" : "text/csv",
    "txt" : "text/plain",
    "doc" : "application/msword",
    "dot" : "application/msword", 
    "docx" : "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "pdf" : "application/pdf",
    "xls" : "application/vnd.ms-excel",
    "xlsx" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "jpg": "image/jpeg",
    "jpeg": "image/jpeg",
    "png": "image/png"
  };
  
  let fileExt = fileName.substring(fileName.lastIndexOf('.')+1);
  
  return extToContentTypes[fileExt] ? extToContentTypes[fileExt.toLowerCase()] : null;
}

export const contentTypeArr = [
  {ext: '.pdf', cnt: 'application/pdf'},
  {ext: '.doc', cnt: 'application/msword'},
  {ext: '.docx', cnt: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'},
  {ext: '.xls', cnt: 'application/vnd.ms-excel'},
  {ext: '.xlsx', cnt: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'},
  {ext: '.ppt', cnt: 'application/vnd.ms-powerpoint'},
  {ext: '.pptx', cnt: 'application/vnd.openxmlformats-officedocument.presentationml.presentation'},
  {ext: '.csv', cnt: 'text/csv; charset=utf-8'},
  {ext: '.txt', cnt: 'text/plain; charset=utf-8'},
  {ext: '.json', cnt: 'application/json'},
  {ext: '.jpg', cnt: 'image/jpeg'},
  {ext: '.jpeg', cnt: 'image/jpeg'},
  {ext: '.png', cnt: 'image/png'},
  {ext: '.gif', cnt: 'image/gif'},
  {ext: '.webp', cnt: 'image/webp'},
  {ext: '.svg', cnt: 'image/svg+xml'},
  {ext: '.zip', cnt: 'application/zip'},
  {ext: '.mp3', cnt: 'audio/mpeg'},
  {ext: '.mp4', cnt: 'video/mp4'}
];